module.exports = __webpack_public_path__ + "img/72-r.194c27d3.png";